import React from 'react';
import PriceChange from './PriceChange';
import Sparkline from './Sparkline';

interface MarketCardProps {
  icon?: React.ReactNode;
  label: string;
  price: string;
  changePercent: number;
  meta?: string;
  selected?: boolean;
  /** Gold tints the tile; everything else stays neutral so the tint means altın. */
  accent?: 'neutral' | 'gold';
  /** Recent prices, oldest first. Omitted or under 2 points renders nothing. */
  sparkline?: number[];
  /** Last data time (HH:mm). Set = market closed: muted price, badge, no sparkline. */
  closedAt?: string;
  onClick?: () => void;
  onDetail?: () => void;
}

const MarketCard: React.FC<MarketCardProps> = ({
  icon, label, price, changePercent, meta, selected, accent = 'neutral', sparkline, closedAt, onClick, onDetail,
}) => {
  const tileClass = accent === 'gold' ? 'icon-tile icon-tile-gold' : 'icon-tile';
  return (
    <div
      onClick={onClick}
      className={`card card-hover relative p-3.5 ${selected ? 'card-selected' : ''}`}
    >
      {onDetail && (
        <button
          onClick={(e) => { e.stopPropagation(); onDetail(); }}
          className="absolute top-2.5 right-2.5 text-[11px] text-gray-600 hover:text-accent-300 transition-colors"
        >
          →
        </button>
      )}
      <div className="flex items-center gap-2.5 mb-2.5 pr-5">
        {icon && <span className={tileClass}>{icon}</span>}
        <span className="text-xs text-gray-400 font-medium truncate">{label}</span>
      </div>
      <div className={`text-num text-[17px] font-semibold leading-tight mb-2 ${closedAt ? 'text-gray-400' : 'text-white'}`}>{price}</div>
      {/* Chip and sparkline share a row: the number and its shape describe the
          same move, and pairing them costs no extra vertical space. */}
      <div className="flex items-center justify-between gap-2">
        {closedAt ? (
          // A flatline + 0.00% reads as broken data; closedness is a state
          <span className="chip chip-neutral">KAPALI · {closedAt}</span>
        ) : (
          <>
            <PriceChange value={changePercent} />
            {sparkline && (
              <Sparkline values={sparkline} change={changePercent} className="w-14 h-6 flex-shrink-0" />
            )}
          </>
        )}
      </div>
      {meta && <div className="text-[11px] text-gray-600 mt-2">{meta}</div>}
    </div>
  );
};

export default MarketCard;
